/**
 * Vue imports
 */
import { createApp, h, resolveComponent } from 'vue';

/**
 * Plain JS imports
 */
import AuthorsLetters from './AuthorsLetters';
import Cookie from './Cookie';
import Hamburger from './Hamburger';
import Header from './Header';
import Loader from './Loader';
import SelectRedirect from './SelectRedirect';
import TopPosts from './TopPosts';
import TwitterSlider from './TwitterSlider';
import SearchField from './SearchField';
import ContactForm from './ContactForm';
import PostGallery from './PostGallery';
import PostTeilen from './PostTeilen';
import PostNav from './PostNav';
import HighlightSlider from './HighlightSlider';
import ReadMore from './ReadMore';
import ShowMore from './ShowMore';

// Vue components
import { registerComponents } from '../../vue/components/index.js';


const CORE_DEBUG = false;

function toCamelCase(str) {
  return str.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
}

function parseComponentProps(elem) {
  const props = {};
  for (const attr of elem.attributes) {
    if (attr.name.startsWith(':')) {
      const key = toCamelCase(attr.name.slice(1));
      try {
         
        props[key] = new Function(`return (${attr.value})`)();
      } catch {
        props[key] = attr.value;
      }
    } else if (attr.name === 'class') {
      props.class = attr.value;
    }
  }
  return props;
}


/**
 * Init stuff
 */

class Core {
  static run(stage) {
    switch (stage) {
    case 'dom':
      CORE_DEBUG && console.log('CORE - DOM ready - running scripts..');
      new AuthorsLetters();
      new Cookie();
      new Hamburger();
      new Header();
      new Loader();
      new SelectRedirect();
      new TopPosts();
      new SearchField();
      new ContactForm();
      new PostGallery();
      new PostTeilen();
      new PostNav();
      new HighlightSlider();
      new ReadMore();
      new ShowMore();
      break;

    case 'page':
      CORE_DEBUG && console.log('CORE - Page ready - running scripts..');
      new TwitterSlider();
      break;

    case 'vue':
      CORE_DEBUG && console.log('CORE - Vue ready running scripts..');
      break;

    default:
      break;
    }
  }
}

/**
 * DOM ready init
 */

const readyDOM = (fn) => {
  if (document.attachEvent
    ? document.readyState === 'complete'
    : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

/**
 * Page ready init
 */

const readyPage = (fn) => {
  window.addEventListener('load', fn);
};

const readyVue = (fn) => {
  window.addEventListener('vueMounted', fn);
};


readyDOM(() => {
  Core.run('dom');

  const vComponents = document.querySelectorAll('[data-vue-component]');
  if (vComponents.length) {
    vComponents.forEach((elem) => {
      const tagName = elem.tagName.toLowerCase();
      const props = parseComponentProps(elem);

      const app = createApp({
        render() {
          return h(resolveComponent(tagName), props);
        },
        mounted() {
          window.dispatchEvent(new CustomEvent('vueMounted', {
            detail: { componentCount: vComponents.length },
          }));
        },
      });
      registerComponents(app);

      const container = document.createElement('div');
      elem.replaceWith(container);
      window.App = app.mount(container);
    });
  }
});

let componentsMounted = 0;
readyVue((e) => {
  componentsMounted++;
  if (!parseInt(e.detail.componentCount)) {
    CORE_DEBUG && console.log('CORE (vue/0) ready');
    Core.run('vue');
  } else if (parseInt(e.detail.componentCount) === componentsMounted) {
    CORE_DEBUG && console.log(`CORE - Vue components mounted count: ${componentsMounted}`);
    Core.run('vue');
  }
});

readyPage(() => {
  Core.run('page');
});

window.addEventListener("message", function(event) {
  try {
    JSON.parse(event.data);
    var message = JSON.parse(event.data);
    if (message.sender == "Flourish" && message.context == "iframe.resize") {
      document.querySelector('iframe[src^="'+message.src+'"]').style.height = message.height+'px';
    }
  } catch {
    //ignore
  }
});
